










import Vue from "vue";
import { mapMutations, mapState } from "vuex";
import { SET_LOADER, RootState } from "./../store/types";
import messages from "@/messages.json";
import axios from "axios";
export default Vue.extend({
  name: "SurveyConfirmation",

  components: {
    Loader: () => import("@/components/UI/Loader.vue"),
    SuccessCard: () => import("@/components/Form/SuccessCard.vue"),
    ErrorCard: () => import("@/components/Form/ErrorCard.vue")
  },

  data: () => ({
    success: false,
    successMessage: "",
    errorMessage: ""
  }),

  computed: {
    ...mapState({
      isLoading: state => (state as RootState).loader
    })
  },

  methods: {
    ...mapMutations({
      setLoader: SET_LOADER
    })
  },

  created() {
    document.title = "PSE - Potwierdź ankietę";
  },

  async mounted() {
    const { token, id } = this.$route.query;
    const { error, success } = messages;

    if (!token || !id) {
      this.errorMessage = error["invalid_parameters"];
      return;
    }

    this.setLoader(true);
    try {
      const res = await axios.post("confirmation", { token, id });
      this.success = true;
      this.successMessage = success["survey_confirmation"];

      if (res.data.slug) {
        setTimeout(() => {
          this.$router.push({
            name: "questionnaire",
            params: { questionnaire: res.data.slug }
          });
        }, 5000);
      }
    } catch (err) {
      const code = err.response.data.code;

      if (code && code in error) {
        this.errorMessage = error[code];
      } else {
        this.errorMessage = error["survey_undefined"];
      }
    }
    this.setLoader(false);
  }
});
